// Contact.js
import React from "react";
import "../../styles/Contact.css";

function Contact() {
    return (
        <div className="contact-container">
            <h2>Contact Me</h2>
            <p>Email: zidiyaocanada@outlook.com</p>
            <p>Email: yaoz25@mcmaster.ca</p>
            <p> More features will be added later</p>
        </div>
    );
}

export default Contact;
